<template>
	<div class="main-containter" v-title data-title="reservaion">
		<PHeader :checkId="'业务领域25'"  :activeNames="'业务领域'"></PHeader>
		
		<article>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 / 业务领域</span>
				<span style="color:#333333;font-size:14px;"> / 业务详情</span>
			</div>
			<div style="width:94%;margin-left:3%;margin-bottom:20px;margin-top:20px;">
				<div style="font-size: 18px;font-weight: 900;color: #98273A;margin-top:20px;">{{item.title}}</div>
				<div style="color: #98273A;font-size: 12px;">{{item.e_title}}</div>
				<div style="margin-top: 5px;width: 20px;height: 3px;background: #98273A;"></div>
				<div style="text-align: left;padding-bottom: 20px;border-bottom: 1px solid #D7D7D7;">
					<v-md-preview  style="text-align:left;" :text="item.content" ref="preview"  id="preview"></v-md-preview>
				</div>
				<div :style="{'text-align': 'left','padding-bottom': '20px','border-bottom': '1px solid #D7D7D7',height:(item.services.split('、').length/2 * 35)+50+'px'}">
					<div style="font-size: 18px;font-weight: 500;color: #98273A;margin-top:20px;">业务范围</div>
					<div v-for="(item,index) in item.services.split('、')" :key="index" style="font-size: 14px;float: left;padding-top: 20px;width: 50%;">
						<span data-v-6df10058="" style="width: 4px; height: 4px; background-color: rgb(152, 39, 58); display: inline-block; margin-bottom: 3px; margin-right: 10px; "></span>
						<span>{{item}}</span>
					</div>
				</div>
				<div style="text-align: left; padding-bottom: 20px; height: 250px;margin-top:20px;">
					<div style="font-size: 18px;color: #98273A;padding-bottom: 10px;">专业律师</div>
					<div v-for="(item,index) in lawyerList" :key="index" :style="{'margin-right':index !=2?'2%':'0','font-size': '14px','width': '32%',float: 'left','padding-top': '10px'}">
						<img style="width: 100%;height: 150px;" :src="item.image">
						<div style="text-align: center;margin-top: 10px;width: 100%;">{{item.name}}</div>
						<div style="text-align: center;font-size: 12px;margin-top: 5px;width: 100%;color: #AAAAAA;">
							<span style="padding-right: 5px;border-right: 1px solid;">{{item.company_address}}</span>
							<span style="padding-left: 5px;">{{item.relationship_name}}</span>
						</div>
					</div>
				</div>
			</div>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	import {queryDetail} from "@/api/service";
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				id: 0,
				item: {},
				up: {},
				next: {},
			}
		},
		created() {
			this.id = this.$route.query.id
			this.queryDetail()
		},
		mounted() {
			this.id = this.$route.query.id
			this.queryDetail()
		},
		activated() {
			this.id = this.$route.query.id
			this.queryDetail()
		},
		methods: {
			queryDetail(){
				let param = {}
				param.id = this.id
				queryDetail(param).then(data => {
						this.item = data.data
						this.lawyerList = []
						for(let i=0;i<3 && i<data.data.lawyerList.length;i++){
							this.lawyerList.push(data.data.lawyerList[i])
						}
					}).catch(error => {
						this.$message.error(error)
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
</style>
